import type { ApiMode } from "../types";

export const API_MODE_KEY = "deskflow.apiMode.v2";

export function loadApiMode(): ApiMode | null {
  return localStorage.getItem(API_MODE_KEY) === "demo" ? "demo" : null;
}

export function saveApiMode(mode: ApiMode): void {
  localStorage.setItem(API_MODE_KEY, mode);
}
